import React, { CSSProperties, FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { getLabel } from '../../../../../helpers/html.utils';
import { ProductListingItemProps } from '../../../../../models/my-account/product-listing/product-listing-item/product-listing-item-component.model';
import sharedStyles from '../shared/listing-item-component.module.scss';
import { EnergyLabelProductInfo } from '../../../../shared';
import { productService } from '../../../../../../../services/product-service';

export const ProductListingItem: FunctionComponent<ProductListingItemProps> = (props: ProductListingItemProps) => {
  return (
    <div
      className={`${sharedStyles['listing-item-container']} ${props.className ?? ''}`}
      style={{ '--tablet-width': props.tabletWidth ?? 'fit-content' } as CSSProperties}>
      <Link to={props.item.pdpUrl} className={sharedStyles['img-container']} onClick={onClick}>
        <img src={props.item.imageUrl} alt={props.item.title} className={sharedStyles.image} />
      </Link>
      <Link
        to={props.item.pdpUrl}
        className={`${sharedStyles.title} ${props.item.price ? sharedStyles['has-price'] : ''}`}
        onClick={onClick}>
        {props.item.title}
      </Link>
      {props.item.energyArea && (
        <EnergyLabelProductInfo
          labels={props.labels}
          energyArea={props.item.energyArea}
          stockCode={props.item.stockCode}
          productService={productService}
        />
      )}
      {props.item.price && <p className={sharedStyles.price}>{props.item.price?.displayValue}</p>}
      {props.item.isInBasket && <p className={sharedStyles['in-basket']}>{getLabel(props.labels, 'in_the_basket')}</p>}
    </div>
  );

  function onClick() {
    props.onClickCallback && props.onClickCallback(props.item);
  }
};
